import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollTaxDetailDTO  {
    _originalTypeClassName = "zERP.BO.PayrollTaxDetailDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollTaxDetailDTO.translate = translateService;
}
this.ItemsDTO = [];
this.Id = null;
this.TaxableAmount = null;
this.NonRegularTaxableAmount = null;
this.TotalTaxableAmount = null;
this.RegularTax = null;
this.NotRegularTax = null;
this.Tax = null;
this.PayrollTaxDetailDTOKey = null;
this._key = this.PayrollTaxDetailDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
TaxableAmount:any;
NonRegularTaxableAmount:any;
TotalTaxableAmount:any;
RegularTax:any;
NotRegularTax:any;
Tax:any;
ItemsDTO:any;
private _PayrollTaxDetailDTOKey:any;
get PayrollTaxDetailDTOKey(): any {
    return this._PayrollTaxDetailDTOKey;
  }
set PayrollTaxDetailDTOKey(value: any) {
    this._PayrollTaxDetailDTOKey = value;
    this._key = value;
  }
static setItemsDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.ItemsDTO == null) $this.ItemsDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ItemsDTO.length > 0) {
                    Domain.PayrollTaxDetailDTO.removeItemsDTO($this, $this.ItemsDTO[0]);
                }

                Domain.PayrollTaxDetailDTO.addManyItemsDTO($this, copyItems);
            }
static addManyItemsDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollTaxDetailDTO.addItemsDTO($this, items[i]);
                }
            }
static addItemsDTO = ($this, item) => {
                if ($this.ItemsDTO == null) $this.ItemsDTO = [];
                if (item == null || $this.ItemsDTO.indexOf(item) > -1) return;
                $this.ItemsDTO.push(item);
}
static addRangeItemsDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollTaxDetailDTO.addItemsDTO($this, item));
            }
static removeItemsDTO = ($this, item) => {
                if ($this == null || $this.ItemsDTO == null || $this.ItemsDTO.indexOf(item) === -1) return;
                var _index = $this.ItemsDTO.indexOf(item);
                $this.ItemsDTO.splice(_index, 1);
}
static clearItemsDTO = ($this) => { $this.ItemsDTO = null; }

static Assign(ptd: any): any{let ptdDTO = new Domain.PayrollTaxDetailDTO();
ptdDTO.Id = ptd?.Id;
ptdDTO.NonRegularTaxableAmount = ptd?.NonRegularTaxableAmount;
ptdDTO.NotRegularTax = ptd?.NotRegularTax;
ptdDTO.RegularTax = ptd?.RegularTax;
ptdDTO.Tax = ptd?.Tax;
ptdDTO.TaxableAmount = ptd?.TaxableAmount;
ptdDTO.TotalTaxableAmount = ptd?.TotalTaxableAmount;
for (let _ii = 0; _ii < (ptd?.Items == null ? 0 : ptd?.Items.length); _ii++) {let i = ptd?.Items[_ii];ptdDTO?.ItemsDTO?.add(Domain.PayrollTaxDetailItemDTO.Assign(i));}
return ptdDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollTaxDetailDTOKey == null || $this.PayrollTaxDetailDTOKey == 0;
            }


}